const DEFAULT_DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  month: '2-digit',
  day: '2-digit',
  year: '2-digit',
}

export function formatDate(
  date: Date | string | undefined,
  options: Intl.DateTimeFormatOptions = DEFAULT_DATE_FORMAT_OPTIONS,
): string {
  if (!date) return ''
  const d = date instanceof Date ? date : new Date(date)
  if (isNaN(d.getTime())) return ''
  return d.toLocaleDateString('en-US', options)
}

/** Formats a date as `yyyy-MM-dd` using its local calendar day (no UTC shift) */
export function formatApiDate(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * Parses a date-only `YYYY-MM-DD` as a local calendar day. `new Date()` reads
 * those strings as UTC midnight, which shows the previous day west of UTC
 */
export function parseApiDate(date?: string): Date | undefined {
  if (!date) return undefined
  const [year, month, day] = date.split('-').map(Number)
  return year && month && day ? new Date(year, month - 1, day) : undefined
}
